import { Text, Box, ThemeUIStyleObject } from 'theme-ui';
import ImgLoader from '~/components/Generic/ImgLoader';
import CTAButton from '~/components/Generic/CTAButton';
import LinkRenderer from '~/components/Generic/LinkRenderer';

const ShopTileCard = ({ card, showNewStyle }: { card: Queries.ShopTileFragmentFragment; showNewStyle: boolean }) => {
  const { CTA, tileTitle = '', background, foreground } = card;

  const baseColor = CTA?.baseColor ?? '';
  const variant = CTA?.variant ?? '';
  const isWhite = /white/i.test(baseColor);
  const isOutline = /outline/i.test(variant);
  const fillHoverColor = isWhite ? 'cloud' : 'darkGrey';

  const newStyle: ThemeUIStyleObject = {
    // height: '34.2rem',
    borderRadius: '0rem',
    aspectRatio: ['1/1', '437/342'],
  };

  const newTextPlacement: ThemeUIStyleObject = {
    left: ['3md'],
    fontSize: 'clamp(3rem, -0.7rem + 4vw, 4.4rem)',
  };

  const newCTAPlacement: ThemeUIStyleObject = {
    bottom: '3md',
    left: '3md',
  };
  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        transform: 'translateZ(0)', // leave this please, safari quirk...
        maxWidth: '100%',
        '& > div > a > :where(h3, div[data-gatsby-image-wrapper]), div[data-gatsby-image-wrapper]': {
          transition: 'transform 0.3s ease-in-out',
        },
        ' &:hover div[data-gatsby-image-wrapper]': {
          transform: 'scale(1.05)',
        },
        '&:hover > div > a > h3': {
          transform: 'translate(0, -50%) scale(0.95)',
        },
        '&:hover button': {
          backgroundColor: isOutline ? baseColor : fillHoverColor,
          color: isWhite ? 'black' : 'white',
          borderColor: isOutline ? baseColor : fillHoverColor,
        },
        ...((showNewStyle && newStyle) ?? {}),
      }}
    >
      {/* @ts-ignore */}
      <LinkRenderer
        slug={CTA?.page?.slug}
        innerLink={CTA?.innerLink}
        href={CTA?.url}
        title={CTA?.page?.title}
        type={CTA?.page?.__typename}
        page={CTA?.page ?? {}}
        locationDetail={'shop_tiles'}
      >
        {!!background && (
          <ImgLoader image={background} forwardSx={{ width: '100%', objectFit: 'cover', height: '100%' }} />
        )}
        <Text
          as="h3"
          dangerouslySetInnerHTML={{ __html: tileTitle ?? '' }}
          sx={{
            position: 'absolute',
            top: '50%',
            left: ['2.4rem', '4rem'],
            transform: 'translate(0, -50%)',
            fontSize: ['clamp(4.2rem, 3rem + 3.5vw, 5.6rem)', 'clamp(4.8rem, -0.7rem + 7vw, 9.6rem)'],
            textTransform: 'uppercase',

            lineHeight: '80%',
            letterSpacing: '-0.04em',
            color: 'white',
            fontWeight: 'medium',
            ...((showNewStyle && newTextPlacement) ?? {}),
          }}
        />
        <CTAButton
          forwardSx={{
            position: 'absolute',
            bottom: ['2.4rem', '4rem'],
            left: ['2.4rem', '4rem'],
            zIndex: 1,
            px: '3md',
            py: 'xs',
            ...((showNewStyle && newCTAPlacement) ?? {}),
          }}
          variant={variant}
          baseColor={baseColor}
          size={CTA?.size ?? ''}
        >
          <Text variant="button" sx={{ fontWeight: 500 }}>
            {CTA?.text}
          </Text>
        </CTAButton>
        {!!foreground && (
          <ImgLoader
            forwardSx={{
              position: 'absolute',
              left: 0,
              top: 0,
              right: 0,
              bottom: 0,
            }}
            image={foreground}
          />
        )}
      </LinkRenderer>
    </Box>
  );
};

export default ShopTileCard;
